import { httpCreate } from './http';

const http = httpCreate('/srv/activity-config');

export const activityConfig = {
	// 获取直播间的扩容范围
	getNumRange(activityId) {
		return http.get(`/onlineNum-range/${activityId}`);
	},
	// 修改直播间的扩容人数
	putNumLimit(activityId, onlineLimit) {
		return http.put(`onlineNum/${activityId}/${onlineLimit}`);
	},
};
